import { jsx as r } from "react/jsx-runtime";
const o = () => /* @__PURE__ */ r("hr", { role: "separator" });
export {
  o as SelectDivider
};
